import request from "./request";
import type { RefreshStatusResponse } from "../shared/api-types/cache";
import { RefreshStatus } from "../shared/api-types/cache";

export { RefreshStatus };

/**
 * Configuration for cache refresh API calls
 */
export interface CacheRefreshConfig {
  baseUrl: string; // e.g., "/certificates", "/aircraft", etc.
  cachePrefix: string; // e.g., "user-compliance-with-courses"
  crewId: number;
}

/**
 * Trigger background cache refresh
 * Generic - works with any cache type
 *
 * @example
 * triggerCacheRefresh({
 *   baseUrl: "/certificates",
 *   cachePrefix: "user-compliance-with-courses",
 *   crewId: 123
 * })
 */
export const triggerCacheRefresh = async (config: CacheRefreshConfig): Promise<RefreshStatusResponse> => {
  const { baseUrl, cachePrefix, crewId } = config;
  const json = await request.post(`${baseUrl}/cache/${cachePrefix}/crews/${crewId}/refresh`);
  return json as RefreshStatusResponse;
};

/**
 * Get cache refresh status
 * Generic - works with any cache type
 *
 * @example
 * getCacheRefreshStatus({
 *   baseUrl: "/certificates",
 *   cachePrefix: "user-compliance-with-courses",
 *   crewId: 123
 * })
 */
export const getCacheRefreshStatus = async (config: CacheRefreshConfig): Promise<RefreshStatusResponse> => {
  const { baseUrl, cachePrefix, crewId } = config;
  const json = await request(`${baseUrl}/cache/${cachePrefix}/crews/${crewId}/refresh/status`);
  return json as RefreshStatusResponse;
};
